import { Http } from '@/lib/http';

export class BankAccountTypeService extends Http {
  constructor() {
    super();
    this.endpoint = 'gl/settings/bank-account-types';
  }

  fetchBankAccountTypes() {
    return this.httpClient().get(`${this.endpoint}`);
  }

  updateBankAccountType(id, updates) {
    return this.httpClient().patch(`${this.endpoint}/${id}`, updates);
  }

}